import {
  INITIALIZE_MESSAGE,
} from '../../constants/ActionTypes'


// 各stateの初期値
// containerで message: state.orderList.message || state.letterOrderList.message || state.followCallOrder.message,
// 等と別stateを組み合わせている場合、ページ遷移から戻ってきた際必ずしも、すべてのmessageが初期化されるとは限らず前のstateが残ってしまうため
export function initializeMessage() {
  return {
    type: INITIALIZE_MESSAGE,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/Common.js